import * as types from './types'
import globals from '@/plugins/globals.js'
import store from '@/store'
import storage from '@/plugins/storage'
import sendbird from '../chat/sendbird'
import { getTranslatedMessage } from '@/plugins/utils'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.REQUEST_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.REQUEST_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.REQUEST_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.REQUEST_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.REQUEST_FILTER_BY, filterBy)
  },
  [types.SET_NEW_REQUEST](state) {
    let language = store.getters['auth/language']
    state.request = JSON.parse(JSON.stringify(state.cleanRequest))
    let location = {
      CultureCode: language + '-' + language.toUpperCase()
    }
    state.request.Contact.Location = location
  },
  [types.SET_REQUESTS](state, requests) {
    requests.forEach(function (element) {
      element.chatUnread = 0
      if (element.StatusName === 'Scheduled') {
        if (element.ScheduleDates !== '') {
          var dates = JSON.parse(element.ScheduleDates)
          if (dates !== undefined && dates !== null) {
            var date = new Date(dates[0].Date)
            element.Scheduled = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
          }
        }
      }
    }, this)
    state.requests = requests
    try {
      if (requests.length > 0) {
        let ids = []
        if (state.requestCount.listWorkOrders !== undefined && state.requestCount.listWorkOrders !== null) {
          for (let wo of state.requestCount.listWorkOrders) {
            ids.push(wo.id)
          }
        }
        // console.log('Calling SendBird for Channel List', ids)
        if (ids.length > 0) {
          sendbird.getChannelList(ids)
        }
      }
    } catch (e) {
      console.error(e)
    }
  },
  [types.SET_REQUEST](state, request) {
    let language = store.getters['auth/language']
    state.request = undefined
    state.noRequest = false
    if (request !== undefined && request !== null) {
      state.request = request[0]
      if (state.request !== undefined && state.request !== null) {
        if (state.request.IsSRS !== null) {
          state.request.IsSRS = state.request.IsSRS.toString()
        }
        if (state.request.IsDrivable !== null) {
          state.request.IsDrivable = state.request.IsDrivable.toString()
        }
        if (state.request.IsMil !== null) {
          state.request.IsMil = state.request.IsMil.toString()
        }
        if (globals.currentPage === 'Pending') {
          state.request.IsSRS = null
          state.request.IsDrivable = null
          state.request.IsMil = null
        }
        let location = {
          CultureCode: language + '-' + language.toUpperCase()
        }
        if (state.request.Contact !== null) {
          state.request.Contact.Location = location
        }
        if (state.request.Id !== null) {
          for (let request of state.requests) {
            if (request.Id === state.request.Id) {
              state.request.chatUnread = request.chatUnread
              break
            }
          }
        }
      } else {
        state.request = undefined
        state.noRequest = true
      }
    }
    // console.log('Service Request', state.request)
  },
  [types.SET_VEHICLEINFO](state) {
    state.newVehicle = JSON.parse(JSON.stringify(state.cleanVehicle))
    state.makes = []
    state.models = []
    state.submodels = []
    state.engines = []
    state.transmissions = []
    state.drivetypes = []
    state.request.Vehicle = JSON.parse(JSON.stringify(state.cleanVehicle))
  },
  [types.SET_REQUESTCOUNTS](state, counts) {
    if (counts !== undefined && counts !== null) {
      if (counts.listWorkOrders !== undefined && counts.listWorkOrders !== null) {
        counts.listWorkOrders = JSON.parse(counts.listWorkOrders)
      }
      state.requestCount = counts
    }
  },
  [types.UPDATE_TOTAL_UNREAD](state, unread) {
    state.totalUnreadChats = unread
  },
  [types.UPDATE_UNREAD](state, channels) {
    for (let channel of channels) {
      for (let request of state.requests) {
        if (channel.name === request.Id.toString()) {
          request.chatUnread = parseInt(channel.unreadMessageCount)
          break
        }
      }
    }
  },
  [types.UPDATE_REQUEST_UNREAD](state, unread) {
    state.requestUnreadCount = unread
  },
  [types.RESET_REQUEST_UNREAD](state, id) {
    state.requestUnreadReset = id
  },
  [types.SET_VIN_SUMMARY](state, vinSummary) {
    state.vinSummary = null
    if (!vinSummary) return

    state.vinSummary = vinSummary
  },
  [types.SET_VIN_SUMMARY_UK](state, vinSummary) {
    state.vinSummary = vinSummary || null

    if (!vinSummary) return

    if (vinSummary.yearId !== null) {
      state.request.Vehicle.Year = parseInt(vinSummary.yearId)
    }

    if (!globals.isMahleRagEnabled()) {
      if (vinSummary.make) state.request.Vehicle.Make.Text = vinSummary.make.name
      if (vinSummary.model) state.request.Vehicle.Model.Text = vinSummary.model.name
    }

    if (vinSummary.submodel) state.request.Vehicle.Submodel.Text = vinSummary.submodel.name
    if (vinSummary.transmission) state.request.Vehicle.Transmission.Text = vinSummary.transmission.name
    if (vinSummary.engine) state.request.Vehicle.Engine.BlockType = vinSummary.engine.name
  },
  [types.SET_VRM_SUMMARY](state, vrmSummary) {
    state.vrmSummary = vrmSummary || null

    if (!vrmSummary) return

    console.log(vrmSummary.vin)

    state.request.Vehicle.VIN = vrmSummary.vin

    if (!vrmSummary.year) return

    state.request.Vehicle.Year = parseInt(vrmSummary.year)

    if (vrmSummary.make) state.request.Vehicle.Make.Text = vrmSummary.make
    if (vrmSummary.model) state.request.Vehicle.Model.Text = vrmSummary.model
    if (vrmSummary.submodel) state.request.Vehicle.Submodel.Text = vrmSummary.subModel
    if (vrmSummary.transmission) state.request.Vehicle.Transmission.Text = vrmSummary.transmission
    if (vrmSummary.engine) state.request.Vehicle.Engine.BlockType = vrmSummary.engine
  },
  [types.SET_YEARS](state, years) {
    state.years = []
    if (years !== undefined && years !== null) {
      years.forEach(element => {
        state.years.push({
          value: element,
          name: element
        })
      })
    }
  },
  [types.SET_MAKES](state, makes) {
    if (makes !== undefined && makes !== null) {
      state.makes = []
      makes.forEach(element => {
        state.makes.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_MODELS](state, models) {
    if (models !== undefined && models !== null) {
      state.models = []
      models.forEach(element => {
        state.models.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_JATO_MAKES](state, makes) {
    // Add "VIN Mismatch" to top of list to give user alternative
    state.jatoMakes = [{ value: -1, name: 'Vin Mismatch' }, ...makes.map(make => ({ value: make.Id, name: make.Text }))]
  },
  [types.SET_JATO_MODELS](state, models) {
    state.jatoModels = []
    state.jatoModels = models.length
      ? [{ value: -1, name: 'Vin Mismatch' }, ...models.map(model => ({ value: model.Id, name: model.Text }))]
      : [{ value: -1, name: 'Vin Mismatch' }]
  },
  [types.SET_JATO_YEARS](state, years) {
    state.jatoYears = years
  },
  [types.SET_JATO_MAKE](state, make) {
    state.vehicleMake = make
    // If "Vin Mismatch" is selected, reset jatoModels
    if (make && make.value === -1) {
      state.jatoModels = [{ value: -1, name: 'Vin Mismatch' }]
      state.jatoModel = { value: -1, name: 'Vin Mismatch' }
    }
  },
  [types.RESET_JATO_MODELS](state) {
    state.jatoModels = [{ value: -1, name: 'Vin Mismatch' }]
  },
  [types.SET_JATO_MODEL](state, model) {
    state.jatoModel = model
  },
  [types.SET_SUBMODELS](state, submodels) {
    if (submodels !== undefined && submodels !== null) {
      state.submodels = []
      submodels.forEach(element => {
        state.submodels.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_ENGINES](state, engines) {
    if (engines !== undefined && engines !== null) {
      state.engines = []
      engines.forEach(element => {
        state.engines.push({
          value: element.Id,
          name: `${element.Liter} ${element.BlockType}${element.Cylinders} - ${element.CID}`
        })
      })
    }
  },
  [types.SET_TRANSMISSIONS](state, transmissions) {
    if (transmissions !== undefined && transmissions !== null) {
      state.transmissions = []
      transmissions.forEach(element => {
        state.transmissions.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_DRIVETYPES](state, drivetypes) {
    if (drivetypes !== undefined && drivetypes !== null) {
      state.drivetypes = []
      drivetypes.forEach(element => {
        state.drivetypes.push({
          value: element.Id,
          name: element.Text
        })
      })
    }
  },
  [types.SET_SCANTYPES](state, scantypes) {
    let _scanTypes = []
    if (scantypes !== undefined && scantypes !== null) {
      for (let type of scantypes) {
        _scanTypes.push({
          value: type.id,
          name: type.text,
          disclaimer: type.disclaimer,
          hasDisclaimer: type.hasDisclaimer,
          serviceElementGroupId: type.serviceElementGroupId
        })
      }
    }
    state.scantypes = _scanTypes
    storage.local.setItem(types.SESSION_SCANTYPES, JSON.stringify(state.scantypes))
  },
  [types.SET_SERVICEELEMENTS](state, serviceelements) {
    let _serviceelements = []
    if (serviceelements !== undefined && serviceelements !== null && serviceelements.length > 0) {
      for (let type of serviceelements) {
        _serviceelements.push({
          id: type.Id,
          value: type.Id,
          name: (type.Translation === null || type.Translation === undefined || type.Translation === '' ? type.Name : type.Translation),
          translation: type.Translation,
          ragRatingTypeId: type.RagRatingTypeId,
          ragRatingLabel: type.RagRatingLabel,
          ethernetCableRequired: type.EthernetCableRequired,
          eVRequiresCode: type.EVRequiresCode,
          customMessage: type.CustomMessage
        })
      }
    } else {
      _serviceelements.push({
        id: 0,
        value: -1,
        name: getTranslatedMessage('rag.serviceelements.none'),
        ragRatingTypeId: 0,
        ragRatingLabel: 'Unknown',
        ethernetCableRequired: 0,
        eVRequiresCode: 0,
        customMessage: ''
      })
    }
    state.serviceelements = _serviceelements
    storage.local.setItem(types.SESSION_SERVICEELEMENTS, JSON.stringify(_serviceelements))
  },
  [types.SET_RAGRATINGVEHICLEID](state, ragRatingVehicleId) {
    if (ragRatingVehicleId !== undefined && ragRatingVehicleId !== null && ragRatingVehicleId !== '') {
      state.ragratingvehicleid = ragRatingVehicleId
    }
    storage.local.setItem(types.SESSION_RAGRATINGVEHICLEID, state.ragratingvehicleid)
  },
  [types.SET_REQUESTID](state, data) {
    if (data !== undefined && data !== null) {
      if (data.id !== undefined && data.id !== null) {
        if (parseInt(data.id) !== 0 && parseInt(data.id) !== 1 && parseInt(data.id) !== 99) {
          state.id = data.id
          state.request.Id = data.id
        }
      }
    }
  },
  [types.SET_STATUSLIST](state, statuslist) {
    if (statuslist !== undefined && statuslist !== null) {
      state.statuslist = statuslist
    }
  },
  [types.RESET_MAHLE_API_ERROR_MSG](state) {
    state.mahleApiErrorMsg = null
    storage.local.setItem(types.SESSION_MAHLE_API_ERROR_MSG, null)
  },
  [types.SET_MAHLE_API_ERROR_MSG](state, msg) {
    storage.local.setItem(types.SET_MAHLE_API_ERROR_MSG, msg)
    state.mahleApiErrorMsg = msg
  },
  [types.UPDATE_REQUEST_RECORD](state, data) {
    let appId = globals.appId()
    let isUK = false
    if (parseInt(appId) === 1) {
      isUK = true
    }
    if (state.request !== undefined && state.request !== null && data !== null) {
      switch (data.item) {
        case 'AppId':
          state.request.AppId = data.value
          break
        case 'RONumber':
          state.request.RONumber = data.value
          break
        case 'Insurance':
          state.request.Vehicle.Insurance.Id = data.value
          break
        case 'CalibrationSetup':
          state.request.CalibrationSetup = data.value
          break
        case 'WindscreenReplaced':
          state.request.WindscreenReplaced = data.value
          break
        case 'CalibrationAttempted':
          state.request.CalibrationAttempted = data.value
          break
        case 'ScanType':
          state.request.ScanType.Id = data.value.Id
          state.request.ScanType.Name = data.value.Text
          state.request.ScanType.ServiceElementGroupId = data.value.ServiceElementGroupId
          break
        case 'ServiceElement':
          state.request.ServiceElement.Id = data.value.Id
          state.request.ServiceElement.Name = data.value.Name
          state.request.ServiceElement.ServiceElementGroupId = data.value.ServiceElementGroupId
          break
        case 'Device':
          state.request.Device.Id = data.value
          break
        case 'DeviceName':
          state.request.Device.FriendlyName = data.value
          break
        case 'VIN':
          state.request.Vehicle.VIN = data.value
          break
        case 'Year':
          state.request.Vehicle.Year = data.value
          break
        case 'Make':
          if (!isUK || globals.isMahleRagEnabled()) {
            state.request.Vehicle.Make.Id = parseInt(data.value)
            state.request.Vehicle.Model.Id = -1
            state.request.Vehicle.Model.Text = 'Vin Mismatch'
            return
          }

          state.request.Vehicle.Make.Text = data.value
          state.request.Vehicle.Model.Text = 'Vin Mismatch'
          break
        case 'MakeName':
          state.request.Vehicle.Make.Text = data.value
          break
        case 'Model':
          if (!isUK || globals.isMahleRagEnabled()) {
            state.request.Vehicle.Model.Id = parseInt(data.value)
            return
          }

          state.request.Vehicle.Model.Text = data.value
          break
        case 'ModelName':
          state.request.Vehicle.Model.Text = data.value
          break
        case 'Model2':
          if (!isUK) {
            state.request.Vehicle.Model.Id = parseInt(data.value)
            for (let model of state.models) {
              if (model.Id === parseInt(data.value)) {
                state.request.Vehicle.Model.Text = model.Text
              }
            }
          }
          break
        case 'Submodel':
          if (!isUK) {
            state.request.Vehicle.Submodel.Id = data.value
          } else {
            state.request.Vehicle.Submodel.Text = data.value
          }
          break
        case 'VRM':
          state.request.Vehicle.VRM = data.value
          break
        case 'Engine':
          if (!isUK) {
            state.request.Vehicle.Engine.Id = data.value
          } else {
            state.request.Vehicle.Engine.BlockType = data.value
          }
          break
        case 'Transmission':
          if (!isUK) {
            state.request.Vehicle.Transmission.Id = data.value
          } else {
            state.request.Vehicle.Transmission.Text = data.value
          }
          break
        case 'DriveType':
          if (!isUK) {
            state.request.Vehicle.DriveType.Id = data.value
          } else {
            state.request.Vehicle.DriveType.Text = data.value
          }
          break
        case 'Odometer':
          state.request.Vehicle.Odometer = data.value
          break
        case 'OdometerUnits':
          state.request.Vehicle.OdometerUnits.Id = data.value
          break
        case 'IsSRS':
          state.request.IsSRS = data.value
          break
        case 'IsMIL':
          state.request.IsMil = data.value
          break
        case 'IsDrivable':
          state.request.IsDrivable = data.value
          break
        case 'ShopComments':
          state.request.ShopComments = data.value
          break
        case 'ScheduleDate':
          state.request.ScheduleDates = []
          if (data.value !== undefined && data.value !== null) {
            data.value = new Date(data.value).toISOString()
            state.request.ScheduleDates.push({
              Date: data.value,
              UserTimeZone: ''
            })
          }
          break
        case 'UserInfo':
          state.request.Location.Id = data.value.location.Id
          state.request.Contact.Id = data.value.id
          state.request.Contact.GivenName = data.value.firstName
          state.request.Contact.FamilyName = data.value.lastName
          state.request.Contact.PhoneNumber = data.value.phone
          state.request.Contact.Email = data.value.email
          state.request.Contact.Username = globals.username
          if (state.request.Id === 0) {
            state.request.CreatedBy = data.value.id
            state.request.CreatedDate = new Date().toISOString()
          }
          state.request.UpdatedBy = data.value.id
          state.request.UpdatedDate = new Date().toISOString()
          if (state.request.ScheduleDates !== undefined && state.request.ScheduleDates !== null) {
            if (state.request.ScheduleDates.length > 0) {
              state.request.ScheduleDates[0].UserTimeZone = data.value.timeZone
            }
          }
          delete state.request.Device.FriendlyName
          delete state.request.Device.SerialNumber
          break
      }
    }
  },
  [types.SET_RAG_SERVICEELEMENTS](state, serviceelements) {
    let _ragServiceElements = []
    if (serviceelements !== undefined && serviceelements !== null && serviceelements.length > 0) {
      for (let type of serviceelements) {
        _ragServiceElements.push({
          id: type.ServiceElementId,
          value: type.ServiceElementId,
          name: type.Name,
          text: type.Text,
          ragRatingTypeId: type.RagRatingTypeId,
          ragRatingVehicleId: type.RagRatingVehicleId,
          deviceTypeId: type.DeviceTypeId,
          ethernetCableRequired: type.EthernetCableRequired,
          eVRequiresCode: type.EVRequiresCode,
          customMessage: type.CustomMessage
        })
      }
    } else {
      _ragServiceElements.push({
        id: 0,
        value: -1,
        name: getTranslatedMessage('rag.serviceelements.none'),
        text: 'Unknown',
        ragRatingTypeId: 0,
        ragRatingVehicleId: null,
        deviceTypeId: 0,
        ethernetCableRequired: false,
        eVRequiresCode: false,
        customMessage: ''
      })
    }
    state.ragServiceElements = _ragServiceElements
  },
  [types.SET_RAG_DEVICETYPES](state, ragDeviceTypes) {
    state.ragDeviceTypes = ragDeviceTypes
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/mutations.js